export default function style(theme) {
  return {
    appBar: {
      boxShadow: "none",
      padding: "0",
      transition: "0.7s",
      backdropFilter:'blur(20px)',
      background:'rgba(0, 0, 0, 0.4) !important',
      zIndex: "20 !important",
    },
    navBar: {
      padding: "8px 20px",
      margin: "auto",
      zIndex: "20 !important",
      maxWidth: "1200px"
    },
    brandingLogo: {
      fontSize: "2.5rem",
      fontFamily: "Poppins",
      textAlign: "left",
      width: "100%",
      fontWeight: 700,
      zIndex: 20,
      color: theme.palette.text.highlight,
      [theme.breakpoints.down("sm")]: {
        fontSize:  "2rem",
      },
    },
    profilePic:{
      borderRadius: "100%",
      border: "2px solid #5D5FEF",
      margin: "2rem auto"
    },
    navLinks: {
      height: "100%",
      width: "100%",
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: 60,
      transition:"0.5s",
    },
    navLink: {
      color: theme.palette.text.primary,
      fontWeight:"300",
      textDecoration: "none",
      padding: "8px 0px",
      display: "inline-block",
      position: "relative",
      lineHeight: "20px",
      display: 'flex',
      gap:'10px',
      alignItems:'center',
      justifyContent:'center',
      "&::after":{
        content: '""',
        position: "absolute",
        width: "100%",
        transform: "scaleX(0)",
        height: "0.5px",
        bottom: "0",
        left: "0",
        backgroundColor: theme.palette.text.primary,
        borderRadius: '20px',
        transformOrigin: "bottom right",
        transition: "transform 0.4s cubic-bezier(0.86, 0, 0.07, 1)",
      },
      "&:hover::after":{
        transform: "scaleX(1)",
        transformOrigin: "bottom left",
      }
    },
    navLinkHighlighted: {
      color: theme.palette.text.highlight,
      textDecoration: "none",
      fontWeight: 500,
      transition: "0.5s",
    },
    resumeBtn: {
      display: "flex",
      alignItems:"center",
      justifyContent:"center",
      marginLeft:"20px",
    },
    menuBtn: {
      color: theme.palette.text.primary,
    },
    mobileNav: {
      background: theme.palette.primary.main,
      height: "100%",
      zIndex: 20,
    },
    brandingTitle: {
      color: theme.palette.text.primary
    },
    brandingDesc: {
      margin: "0.2rem 0rem 0.5rem",
      color: theme.palette.text.tertiary,
    },
    listItem: {
      padding: "12px 16px",
      color: theme.palette.text.primary,
      cursor: "default",
      "& *": {
        color: theme.palette.text.primary,
      },
      background: "transparent",
      borderLeft: `2px solid transparent`,
      transition: "0.3s",
    },
    listItemHighlighted: {
      padding: "12px 16px",
      color: theme.palette.text.primary,
      cursor: "default",
      "& *": {
        color: theme.palette.text.primary,
      },
      background: `${theme.palette.secondary.darkGrey} !important`,
      borderLeft: `2px solid ${theme.palette.text.highlight}`,
    },
    contactBtn: {
      width: "170%",
      border: `1px solid ${theme.palette.text.highlight}`,
      background: "transparent",
      color: theme.palette.text.primary,
      borderRadius: 50,
      "&:hover": {
        background: `${theme.palette.text.highlight}`,
        color: theme.palette.text.primary,
      },
    },
    divider: {
      background: theme.palette.primary.main,
      height: 4,
    },
    listItemIcon: {
      display: "flex",
      marginRight: 10,
    },
  };
}
